import React, { FC } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

type Props = {
  showModal: boolean;
  onCancel?: () => void;
  unSubscribe: () => Promise<void>;
};

export const CancelSubscriptionModal: FC<Props> = ({
  showModal,
  onCancel,
  unSubscribe,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={showModal} onHide={onCancel} centered>
      <Modal.Header className="border-0 text-dark" closeButton>
        <Modal.Title>{t("unSubscribe.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center text-dark">
        <p className="mb-4">{t("unSubscribe.description1")}</p>
        <p className="mb-4">{t("unSubscribe.description2")}</p>
        <Row className="gx-2">
          <Col xs={12} sm={6}>
            <Button
              variant="outline-primary"
              className="py-3 w-100 "
              onClick={() => {
                unSubscribe();
                onCancel();
              }}
            >
              {t("unSubscribe.Cancel")}
            </Button>
          </Col>
          <Col xs={12} sm={6} className="mb-3 mb-lg-0">
            <Button
              variant="primary"
              className="fw-bold text-white py-3 w-100"
              onClick={onCancel}
            >
              {t("unSubscribe.Keep")}
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
